export default {
  'verticalPrivilege.deleteTip':
    'Are you sure to delete the menu or view and configured services?',
  'verticalPrivilege.operationSuccess': 'Operation successful!',
  'verticalPrivilege.menuNameID': 'Menu Name(menuId)',
  'verticalPrivilege.serviceCount': 'Service Count',
  'verticalPrivilege.serviceCountTip':
    'Number of services in the current menu or view',
  'verticalPrivilege.subViewCount': 'Sub View Count',
  'verticalPrivilege.subViewCountTip':
    'Number of sub views in the current menu or view',
  'verticalPrivilege.referencedCount': 'Referenced Count',
  'verticalPrivilege.referencedCountTip':
    'Number of references by menu or view',
  'verticalPrivilege.uploadedTip':
    'The selected file type does not match, only zip can be uploaded',
  'verticalPrivilege.uploadedSuccess': 'file uploaded successfully',
  'verticalPrivilege.uploadedFail': 'file upload failed.',
  'verticalPrivilege.addRootMenu': 'Add Root Menu',
  'verticalPrivilege.upload': 'Upload',
  'verticalPrivilege.download': 'Download',
  'verticalPrivilege.history': 'History',
  'verticalPrivilege.refreshCache': 'Refresh Cache',
  'verticalPrivilege.fileName': 'File Name',
  'verticalPrivilege.center': 'Center',
  'verticalPrivilege.uploadTime': 'Upload Time',
  'verticalPrivilege.uploader': 'Uploader',
  'verticalPrivilege.startTime': 'Start Time',
  'verticalPrivilege.endTime': 'End Time',
  'verticalPrivilege.addMenuTip':
    'The menu or view already exists and cannot be added!',
  'verticalPrivilege.service': 'Service',
  'verticalPrivilege.referencedMenu': 'Referenced Menu',
  'verticalPrivilege.menuID': 'Menu ID',
  'verticalPrivilege.selectMenu': 'Select a Menu',
  'verticalPrivilege.menuName': 'Menu Name',
  'verticalPrivilege.viewUrl': 'View Url',
  'verticalPrivilege.menu': 'Menu',
};
